// extracted by mini-css-extract-plugin
export default {"body":"FilterWrapper_body__HEHc4","title":"FilterWrapper_title__TpM6z","header":"FilterWrapper_header__dMKkj","border":"FilterWrapper_border__yaSkK"};